import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonicPageComponent } from '@libs/core/ionic-hooks';
import { AuthResultEnum } from '@libs/core/auth';
import { AlertController, IonicModule, LoadingController, NavController, ViewWillEnter } from '@ionic/angular';
import { StatusBarService } from '@libs/ui/status-bar';
import { NavigationBarService } from '@libs/ui/navigation-bar';
import { AfterSplashScreen } from '@libs/util/shared';
import { AuthService } from '@libs/core/auth-fma';

@AfterSplashScreen()
@Component({
  selector: 'fma-login.page',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule],
})
export class LoginPage extends IonicPageComponent implements ViewWillEnter {
  private authService = inject(AuthService);
  private navController = inject(NavController);
  private loadingCtrl = inject(LoadingController);
  private alertController = inject(AlertController);
  private statusBarService = inject(StatusBarService);
  private navigationBarService = inject(NavigationBarService);

  override async ionViewWillEnter() {
    super.ionViewWillEnter();
    await Promise.all([await this.statusBarService.setOverlaysWebView({ overlay: true }), await this.navigationBarService.hide()]);
  }

  async loginClick() {
    const loading = await this.loadingCtrl.create();

    await loading.present();

    const authResult = await this.authService.authenticate();

    await loading.dismiss();

    if (authResult === AuthResultEnum.SUCCESS) {
      await this.navController.navigateRoot('/');
      return;
    }

    if (authResult === AuthResultEnum.NOT_AUTHORIZED) {
      return;
    }

    if (authResult === AuthResultEnum.FORGOT_PASSWORD) {
      const alert = await this.alertController.create({
        header: 'Password cambiata',
        message: `La tua password è stata cambiata. Per continuare, effettua l'accesso.`,
        buttons: ['OK'],
      });

      await alert.present();
      return;
    }

    const alert = await this.alertController.create({
      header: 'Errore imprevisto',
      message: `Si è verificato un errore durante l'accesso. Se il problema persiste, contattare il supporto.`,
      buttons: ['OK'],
    });

    await alert.present();
  }
}
